import { Route } from 'react-router-dom';

import { Requirements } from './requirements.component';

export function ApplicationsRequirementsRoutes() {
    return (
        <Route path='requirements'>
            <Route
                path='requirements'
                element={<Requirements />}
            />
        </Route>
    );
}
